// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"8b11b2a3","782":"aba1d9a8"}[chunkId] + ".chunk.css";
};